export default __webpack_public_path__ + "static/media/20.f12bec89.svg";